// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"96ff2f29","37":"9555b0cc","115":"9a10b371","135":"f61452e1","306":"fa4dd38b","331":"ca6806e9","403":"9e7cb4f2","417":"82fdd83a","442":"06a36acb","541":"4ef1f846","708":"6cafe512"}[chunkId] + ".chunk.js";
};